import axios from 'axios'
import qs from 'qs'
import uni from './webview.js'
var utils = {};

//自适应
(function(doc, win) {
	var docEl = doc.documentElement,
		resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
		recalc = function() {
			var clientWidth = docEl.clientWidth
			if (!clientWidth) return
			docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
		}

	recalc()
	if (!doc.addEventListener) return
	win.addEventListener(resizeEvt, recalc, false)
})(document, window)

//请求
axios.defaults.withCredentials = true;
let ua = navigator.userAgent;
axios.interceptors.request.use(function(config) {
	config.headers['cToken'] = utils.getParam('cToken') || '';
	config.headers['adminToken'] = utils.getParam('adminToken') || '';
	config.headers['clanguage'] = 'en-US';
	if (ua.indexOf('flb_android') != -1) {
		config.headers['deviceId'] = utils.getParam('staffDeviceId');
	}
	return config;
});
utils.axiosRequest = (method, url, params, callback, fromData) => {
	utils.loadGif.show();
	if (method.toLocaleLowerCase() === 'post') {
		if (fromData) {
			params = qs.stringify(params);
		}
		axios({
			method: method,
			url: url,
			data: params
		}).then(function(res) {
			callback(res.data);
		}).catch(() => {
			utils.loadGif.hide();
		});
	} else {
		axios.get(url, {
			params: params
		}).then(function(res) {
			callback(res.data);
		}).catch(() => {
			utils.loadGif.hide();
		});
	}
}

// 添加响应拦截器
axios.interceptors.response.use(function(response) {
	// 对响应数据做点什么
	if (response.data.code == "1002") {
		if(utils.getEnv()){
			try{
				localStorage.clear();
				uni.postMessage({
					data: {
						action: 'toLogin'
					}
				});
			}
			catch (e) {
				console.log(e)
			}
		}
		else{
			localStorage.clear();
			if (location.href.indexOf('/index.html') == -1 && location.href.indexOf('.html') != -1) {
				location.href = "./login.html";
			}
		}
	} else if (response.data.code == "11002") { //催收模块,电销，审核模块
		if (location.href.indexOf('/collectionLogin.html') == -1) {
			location.href = "./collectionLogin.html";
		}
	}
	return response;
}, function(error) {
	// 对响应错误做点什么
	return Promise.reject(error);
});

//微信jssdk配置
utils.getJsApiconfig = function(ajaxUrl) {
	axios.get(ajaxUrl, { //params参数必写 , 如果没有参数传{}也可以
			params: {
				url: window.location.href
			}
		})
		.then(function(res) {
			var data = res.data;
			if (data.status == "0") {
				wx.config({
					debug: false,
					appId: data.data.appId,
					timestamp: "" + data.data.timestamp,
					nonceStr: data.data.nonceStr,
					signature: data.data.signature,
					jsApiList: [
						'checkJsApi',
						'onMenuShareTimeline',
						'onMenuShareAppMessage',
						'onMenuShareQQ',
						'onMenuShareWeibo',
						'hideMenuItems',
						'showMenuItems',
						'hideAllNonBaseMenuItem',
						'showAllNonBaseMenuItem',
						'translateVoice',
						'startRecord',
						'stopRecord',
						'onRecordEnd',
						'playVoice',
						'pauseVoice',
						'stopVoice',
						'uploadVoice',
						'downloadVoice',
						'chooseImage',
						'previewImage',
						'uploadImage',
						'downloadImage',
						'getLocalImgData',
						'getNetworkType',
						'openLocation',
						'getLocation',
						'hideOptionMenu',
						'showOptionMenu',
						'closeWindow',
						'scanQRCode',
						'chooseWXPay',
						'openProductSpecificView',
						'addCard',
						'chooseCard',
						'openCard'
					]
				});
			} else {
				console.log("页面加载失败，请刷新");
			}
		});
};

//设置来源 1:PC,2:微信(android),3:android,4:ios,5:其他,6:android浏览器,7:ios浏览器,.8微信(ios)
var origin;
var source = '';
var os = function() {
	var ua = navigator.userAgent,
		isWindowsPhone = /(?:Windows Phone)/.test(ua),
		isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
		isAndroid = /(?:Android)/.test(ua),
		isFireFox = /(?:Firefox)/.test(ua),
		isChrome = /(?:Chrome|CriOS)/.test(ua),
		isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox &&
			/(?:Tablet)/.test(ua)),
		isPhone = /(?:iPhone)/.test(ua) && !isTablet,
		isPc = !isPhone && !isAndroid && !isSymbian,
		isWechat = /(?:MicroMessenger)/.test(ua),
		isAndroidApp = /(?:wallet_android)/.test(ua),
		isiOSApp = /(?:wallet_iOS)/.test(ua);

	return {
		isTablet: isTablet,
		isPhone: isPhone,
		isAndroid: isAndroid,
		isPc: isPc,
		isWechat: isWechat,
		isAndroidApp: isAndroidApp,
		isiOSApp: isiOSApp
	};
}();
! function() {
	if (os.isPc) {
		origin = 1;
		source = 'pc浏览器';
	} else if (os.isWechat) {
		if (os.isAndroid) {
			origin = 2;
			source = 'Android微信';
		} else if (os.isPhone) {
			origin = 8;
			source = 'ios微信';
		}
	} else {
		if (os.isAndroidApp) {
			origin = 3;
			source = 'AndroidApp';
		} else if (os.isiOSApp) {
			origin = 4;
			source = 'iosApp';
		} else if (os.isPhone) {
			origin = 7;
			source = 'ios浏览器';
		} else if (os.isAndroid) {
			origin = 6;
			source = 'Android浏览器';
		} else {
			origin = 5;
			source = '其他';
		}
	}
	utils.origin = origin;
}();

//时间实例化
utils.myDate = function(date) {
	if (date == null || date == undefined || date == 'null') {
		return "";
	}
	return new Date(date).Format("yyyy-MM-dd");
}
Date.prototype.Format = function(fmt) { //author: meizz
	var o = {
		"M+": this.getMonth() + 1, //月份
		"d+": this.getDate(), //日
		"h+": this.getHours(), //小时
		"m+": this.getMinutes(), //分
		"s+": this.getSeconds(), //秒
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度
		"S": this.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt))
		fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt))
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
				.length)));
	return fmt;
};

//当天
utils.getCurrDate = function() {
	var nowDate = new Date();
	var nowTime = nowDate.getTime();
	var date = utils.myDate(nowTime);
	var startDate = date + ' 00:00:00';
	var endDate = date + ' 23:59:59';
	return [startDate, endDate];
};

//时间间隔
utils.getDateRange = (type, dateVal, num = 1) => {
	let startTimeStamp = null;
	let endTimeStamp = null;
	if (type == "end") {//截止日期
		startTimeStamp = dateVal - 24 * 60 * 60 * 1000 * Number(num);
		endTimeStamp = dateVal
	}
	if(type == "start"){//起始日期
		startTimeStamp = dateVal
		endTimeStamp = dateVal + 24 * 60 * 60 * 1000 * Number(num);
	}
	let startDate = utils.myDate(startTimeStamp) + ' 00:00:00';;
	let endDate = utils.myDate(endTimeStamp) + ' 23:59:59';
	return [startDate, endDate];
};

//提示框
utils.logStr = function(str) {
	var div = document.createElement('div');
	var p = document.createElement('p');
	p.innerHTML = str;
	div.className = 'throw-tips-wrap';
	div.appendChild(p);
	document.body.appendChild(div);
	setTimeout(function() {
		div.parentNode.removeChild(div);
	}, 1000);
};

//存参
utils.setParam = function(key, val) {
	if (val != '{}' && val != undefined) {
		localStorage.setItem(key, val);
	}
};

//取参
utils.getParam = function(key) {
	var val = '';
	if (utils.getQueryString(key)) {
		val = utils.getQueryString(key);
	} else if (localStorage.getItem(key) && localStorage.getItem(key) != 'undefined') {
		val = localStorage.getItem(key);
	}
	return val;
};

//消参
utils.removeParam = function(key) {
	localStorage.removeItem(key);
};

//存cookie
utils.setCookie = function(key, val) {
	var d = new Date();
	d.setDate(d.getDate() + 180);
	document.cookie = key + '=' + val + '; expires=' + d.toGMTString() + '; path=/';
};

//取cookie值
utils.getCookie = (objName) => {
	var arrStr = document.cookie.split("; ");
	for (var i = 0; i < arrStr.length; i++) {
		var temp = arrStr[i].split("=");
		if (temp[0] == objName) {
			return decodeURI(temp[1]);
		}
	}
};

//等待效果
utils.loadGif = {
	parentDiv: '',
	index: 0,
	show: function() {
		if (!this.index) {
			this.parentDiv = document.createElement('div');
			var conDiv = document.createElement('div');
			this.parentDiv.className = 'wait-bg';
			conDiv.className = 'wait-con';
			this.parentDiv.appendChild(conDiv);
			document.body.appendChild(this.parentDiv);
		}
		this.index++;
	},
	hide: function() {
		try {
			this.index--
			if (this.index <= 0 && this.parentDiv) {
				this.parentDiv.parentNode.removeChild(this.parentDiv);
			}
		} catch (e) {
			console.log(e);
		}

	}
};

//判断是否是微信
utils.isWeixn = function() {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true;
	} else {
		return false;
	}
}

//获取url后面参数
utils.getQueryString = function(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return decodeURIComponent(r[2]);
	return null;
};

//获取url后面参数(不解密)
utils.getEncryptionQueryString = function(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return r[2];
	return null;
};

//身份证验证
utils.validateIdCard = function(idCard) {
	//15位和18位身份证号码的正则表达式
	var regIdCard =
		/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;

	//如果通过该验证，说明身份证格式正确，但准确性还需计算
	if (regIdCard.test(idCard)) {
		if (idCard.length == 18) {
			var idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9,
				10, 5, 8, 4, 2); //将前17位加权因子保存在数组里
			var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
			var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
			for (var i = 0; i < 17; i++) {
				idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
			}
			var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
			var idCardLast = idCard.substring(17); //得到最后一位身份证号码
			//如果等于2，则说明校验码是10，身份证号码最后一位应该是X
			if (idCardMod == 2) {
				if (idCardLast == "X" || idCardLast == "x") {
					return true;
				}
			} else {
				//用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
				if (idCardLast == idCardY[idCardMod]) {
					return true;
				}
			}
		}
	}
	return false;
}

utils.formatPrice = function(money) {
	if (money) {
		money = String(money);
		var left = money.split('.')[0];
		var right = money.split('.')[1];
		right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') :
		'.00'; //此处保留两位小数，可根据情况是适当更改
		var temp = left.split('').reverse().join('').match(/(\d{1,3})/g); // 此处每三位隔开
		return (Number(money) < 0 ? "-" : "") + temp.join('.').split('').reverse().join('');
	} else {
		return money
	}
}

//复制
utils.copyText = function(text) {
	const input = document.createElement('input')
	input.setAttribute('value', text)
	document.body.appendChild(input)
	input.select()
	input.setSelectionRange(0, text.length); //兼容ios-safari核心代码
	document.execCommand('Copy')
	document.body.removeChild(input);
	utils.logStr('Copy Success')
}

// fixNum:保留的小数位数
//小数转为百分比，并四舍五入保留几位小数
utils.toFixPercent = (num = 0, fixNum = 2) => {
	let num1 = Number(num) * 100 || 0;
	let fixNum1 = Math.pow(10, Number(fixNum));
	return Math.round(num1 * fixNum1) / fixNum1 + '%';
}

//日期格式的转换
utils.convertDate = (date) => {
	if(date){
		let dDate = date && date.split("-");
		let newDate = dDate[2] + "-" + dDate[1]+ "-" + dDate[0];
		return newDate
	}
}

//计算日期推迟
utils.delayDate = (dueDate,term) => {
	if(dueDate){
		let delayDay = 150 - Number(term);
		let delayTime = new Date(dueDate).getTime() + delayDay * 24 * 60 * 60 * 1000;
		let dalayDate = utils.myDate(delayTime);
		// let dalayNewDate = utils.convertDate(dalayDate);
		return dalayDate
	}
}

//计算今天日期推迟
utils.delayToday = (date,term) => {
	if(date && term){
		let delayDay = date.getTime() - 24 * 60 * 60 * 1000;
		let delayTime = delayDay + Number(term) * 24 * 60 * 60 * 1000;
		let dalayDate = utils.myDate(delayTime);
		// let dalayNewDate = utils.convertDate(dalayDate);
		return dalayDate
	}
}

//月份英文缩写对照
utils.dateFormatMatch = (date) => {
	if(date){
		const dateArr = date.split("-");
		const year = dateArr[0];
		const month = dateArr[1];
		const day = dateArr[2];
		const monthToEn = {
			"01" : "Jan.",
			"02" : "Feb.",
			"03" : "Mar.",
			"04" : "Apr.",
			"05" : "May",
			"06" : "Jun.",
			"07" : "Jul.",
			"08" : "Aug.",
			"09" : "Sep.",
			"10" : "Oct.",
			"11" : "Nov.",
			"12" : "Dec.",
		}
		const monthEn = monthToEn[month];
		return monthEn + day + "," + year
	}
}

utils.getEnv = () =>{
	let ua = navigator.userAgent;
	if(ua.indexOf("uni-app") > -1 || ua.indexOf("funpera_ios") > -1){
		return true
	}
	else{
		return false
	}
}
utils.backLogin = () =>{
	if(utils.getEnv()){
		try{
			localStorage.clear();
			uni.postMessage({
				data: {
					action: 'toLogin'
				}
			});
		}
		catch (e) {
			console.log(e)
		}
	}
	else{
		localStorage.clear();
		if (location.href.indexOf('/index.html') == -1) {
			location.href = "./login.html";
		}
	}
}
utils.backHome = () =>{
	if(utils.getEnv()){
		try {
			uni.postMessage({
				data: {
					action: 'home'
				}
			});
		} catch (e) {
			console.log(e)
		}
	}
	else{
		location.href = "./index.html"
	}
}

export default utils
